// extracted by mini-css-extract-plugin
module.exports = {"previewBox":"Preview_previewBox__2cSuJ","preview":"Preview_preview__3fxDY"};